import { PipelineDestinationSubscriptionsIndexPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_authenticated/workspaces/$workspaceId/pipelines/destinations/$destinationId/subscriptions/',
)({
  component: PipelineDestinationSubscriptionsIndexPage,
});
